window.requestAnimationFrame = (function() {
    return  window.requestAnimationFrame       ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame    ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
}());
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
var app = {};
///<reference path="main.js">
/**	
 * SI JavaScript library
 *
 * @author Jeremy Burton - jeremy@select-interactive.com
 * @version 0.1.1
 *
 * @description To provide crossbrowser support for Select Interactive
 *   projects without relying on jQuery.
 *   
 * Featured detection and polyfill for
 *   Promises
 *   Fetch
 * 
 * Targeting features such as:
 *   forEach
 *   .matchMedia support
 *   equal height columns
 *   fetch
 */
( function( window, doc, undefined ) {

	// $ - maps to querySelector to return an element
	// @elements - a node list of elements or selector
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	var $ = function( expr, context ) {
		return typeof expr === 'string' ? ( context || doc ).querySelector( expr ) : expr || null;
	};

	// $$ - maps to querySelectorAll to return a node list of elements
	// @expr - the selector expression to search for
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	var $$ = function( expr, context ) {
		return typeof expr === 'string' ? ( context || doc ).querySelectorAll( expr ) : expr || null;
	};

	// $.addScript - helper function to load scripts
	// @src - String - the source of the script to load
	// @parent - Element - the element that the script should be appended to
	// @async - Boolean - should the script be loaded async
	$.addScript = function( src, parent, async, onload ) {
		var script = doc.createElement( 'script' );
		script.src = src;
		script.async = async;

		if ( onload ) {
			script.onload = onload;
		}

		parent.appendChild( script );
	};

	// if we need to polyfill promises
	if ( typeof self.Promise === 'undefined' || !self.Promise ) {
		$.addScript( '/bower_components/es6-promise/promise.min.js', doc.querySelector( 'head' ), true );
	}

	// If we need to polyfill fetch
	if ( typeof self.fetch === 'undefined' || !self.fetch ) {
		$.addScript( '/bower_components/fetch/fetch.min.js', doc.querySelector( 'head' ), true );
	}

	// $.forEach / window.forEachElement = traverses a node list of elements and executes a function over them
	// @elements - a node list of elements or selector
	// @fn - the function to execute over the list of elements
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	$.forEach = function( elements, fn, context ) {
		var i = 0,
            len;

		if ( !elements || typeof elements === 'function' ) {
			console.log( 'elements is not a valid node list.' );
			return;
		}

		if ( typeof elements === 'string' || elements instanceof String ) {
			elements = $$( elements, context );
		}

		len = elements.length;

		for ( ; i < len; i++ ) {
			if ( fn( elements[i], i ) ) {
				break;
			}
		}
	};

	// keep backwards compatibility for forEachElement
	window.forEachElement = $.forEach;

	// $.addEvent - traverses a node list of elements and attaches and event handler to them
	// @elements - a node list of elements or selector 
	// @evt - the event to watch for (i.e. 'click', 'mouseenter')
	// @fn - the function to execute when the event is raised
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	$.addEvent = function( elements, evt, fn, context ) {
		if ( !elements || typeof elements === 'function' ) {
			console.log( 'elements is not a valid node list.' );
			return;
		}

		if ( typeof elements === 'string' || elements instanceof String ) {
			elements = $$( elements, context );
		}

		$.forEach( elements, function( el ) {
			el.addEventListener( evt, function( e ) {
				fn( e, el );
			}, false );
		} );
	};

	// $.findUp - helper function to recursively traverse up the DOM to find a specified element 
	// @startEl - the element that we start at and move up from
	// @selector - the selector of the element we are looking for
	// @attr - optional - the data attribute of the element we may want a value for
	// @endTag - optional - the selector of the end tag to stop at. Defaults to the body tag.
	// @fn - optional - a function to run once the element has been found
	$.findUp = function( startEl, selector, attr, endTag, fn ) {
		var el = startEl,
			rspObj = {};

		if ( !endTag ) {
			endTag = doc.body;
		}

		function moveUp() {
			if ( $.matches( el, selector ) ) {
				rspObj = {
					el: el,
					val: attr && attr.length ? el.getAttribute( attr ) : ''
				};

				if ( fn ) {
					fn( rspObj );
				}

				return rspObj;
			}
			else {
				el = el.parentNode;

				if ( el === endTag || $.matches( el, endTag ) ) {
					return null;
				}
				else {
					return moveUp();
				}
			}
		}

		return moveUp();
	};

	// $.mq - helper function to check for mediaquery
	// @mediaQuery - the mediaquery to test for (i.e. '(min-width:1024px)')
	$.mq = function( mediaQuery ) {
		return !( window.matchMedia ) || ( window.matchMedia && window.matchMedia( mediaQuery ).matches );
	};

	// keep backwards compatibility for mq
	window.mq = $.mq;

	// $.eqHeight - Helper function to set columns to the same height
	// @context - Optional - Element - the parent element to find rows in. Defaults to body.
	$.eqHeight = function( context ) {
		if ( !context || !context.querySelector ) {
			context = doc;
		}

		// if the promise polyfill hasn't loaded for browsers that need it
		if ( typeof self.Promise === 'undefined' || !self.Promise ) {
			setTimeout( function() {
				$.eqHeight( context );
			}, 10 );

			return;
		}

		// collect all of the rows
		$.forEach( '.eq-height', function( row ) {
			var cols = $$( '.eq-height-item', row ),

				// keep all the image promises as an array
				imagePromises = [];

			// only if we are over a mq of 768px or the row has class .mbl-eq-height
			if ( $.mq( '(min-width:768px)' ) || row.classList.contains( 'mbl-eq-height' ) ) {

				// check if this is large item only
				if ( !row.classList.contains( 'eq-height-item-lg' ) || $.mq( '(min-width:1024px)' ) ) {
					// loop through any images, create a promise for them and add to the imagePromises array
					$.forEach( 'img', function( img ) {
						imagePromises.push( new Promise( function( resolve, reject ) {
							// the image is cached (or has already loaded?)
							if ( img.complete ) {
								resolve( this );
							}
							else {
								// image has loaded
								img.addEventListener( 'load', function() {
									console.log( 'image loaded' );
									resolve( this );
								}, false );
							}
						} ) );
					}, row );

					// if there are images, wait for them to all load before setting the column height
					if ( imagePromises.length ) {
						Promise.all( imagePromises ).then( function() {
							// all images have been loaded
							setColumnHeights( cols );
						}, function() {
							console.warn( 'An image has failed to load.' );
						} );
					}

						// if no images in the container/row, set the column heights now
					else {
						setColumnHeights( cols );
					}
				}
				else {
					$.forEach( cols, function( col ) {
						col.classList.add( 'in' );
					} );
				}
			}
			else {
				$.forEach( cols, function( col ) {
					col.classList.add( 'in' );
				} );
			}
		}, context );

		function setColumnHeights( cols ) {
			var h = 0;

			// find the tallest column
			$.forEach( cols, function( col ) {
				if ( col.offsetHeight > h ) {
					h = col.offsetHeight;
				}
			} );

			// set the height of all the columns to the tallest one
			$.forEach( cols, function( col ) {
				col.style.height = h + 'px';
				col.classList.add( 'in' );
			} );
		}
	};

	// on load let's run eqHeight
	window.addEventListener( 'load', $.eqHeight );

	// $.fetch - Replacing Ajax
	// url - String - the url to fetch
	// options - JSON object - options such as data, method, etc...
	// type - optional - String - the method type. Set to 'GET' to perform a GET request
	$.fetch = function( url, options, type, callbackFn ) {
		var opts, headers;

		// if no url was passed in break now
		if ( !url ) {
			console.warn( 'No url provided to fetch' );
			return;
		}

		// if the promise polyfill hasn't loaded yet
		//   overwrite .then and wait 100 milliseconds then try again.
		if ( typeof self.Promise === 'undefined' || !self.Promise ) {
			return {
				then: function( fn ) {
					setTimeout( function() {
						return $.fetch( url, options, type, fn );
					}, 100 );
				}
			};
		}

		// if the fetch polyfill hasn't loaded yet
		//   overwrite .then and wait 100 milliseconds then try again.
		if ( !self.fetch ) {
			return {
				then: function( fn ) {
					setTimeout( function() {
						return $.fetch( url, options, type, fn );
					}, 100 );
				}
			};
		}
		else {
			// init options to empty object if none were passed in
			if ( !options ) {
				options = {};
			}

			// check fetch request type -- assuming this would a POST request
			if ( !type || type !== 'GET' ) {
				// if additional headers need to be added
				headers = app.util.extend( {
					'Accept': 'application/json',
					'Content-type': 'application/json'
				}, options.headers || {} );

				// setup some default options for a POST request
				//  and extend to include any options that were passed in
				//  specifically the body property for webservice parameters
				opts = app.util.extend( {
					url: url,
					body: '',
					method: 'POST'
				}, options );

				// make sure we include all of the needed headers
				opts.headers = headers;

				// make sure the body property has been stringified
				if ( opts.body && typeof opts.body !== 'string' && opts.body !== {} ) {
					opts.body = JSON.stringify( opts.body );
				}

				// make the fetch call
				return fetch( url, opts ).then( function( rsp ) {
					return rsp.json();
				} ).then( function( data ) {
					if ( callbackFn ) {
						callbackFn( data.d );
					}
					else {
						return data.d;
					}
				} ).then( function( rsp ) {
					return JSON.parse( rsp );
				} );
			}
			else {
				// if additional headers need to be added
				headers = app.util.extend( {
					'Content-Type': 'text/plain'
				}, options.headers || {} );
				
				// setup default options for a GET request
				//  expecting text/plain content type by default
				opts = app.util.extend( {
					method: 'GET'
				}, options );

				// make sure we include all of the needed headers
				opts.headers = headers;

				// make the fetch call
				return fetch( url, opts ).then( function( rsp ) {
					return rsp.text();
				} ).then( function( rsp ) {
					if ( callbackFn ) {
						callbackFn( rsp );
					}
					else {
						return rsp;
					}
				} );
			}
		}
	};

	$.matches = function( elm, selector ) {
		var _matches = ( elm.document || elm.ownerDocument ).querySelectorAll( selector ),
			i = _matches.length;
		while ( --i >= 0 && _matches.item( i ) !== elm ) { }
		return i > -1;
	};

	app.$ = $;
	app.$$ = $$;
}( window, window.document, undefined ) );

// Polyfill for CustomEvent
( function() {

	if ( typeof window.CustomEvent === 'function' ) {
		return false;
	}

	function CustomEvent( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent( 'CustomEvent' );
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
} )();

// Avoid 'console' errors in browsers that lack a console
( function() {
	var method;
	var noop = function() { };
	var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = ( window.console = window.console || {} );

	while ( length-- ) {
		method = methods[length];

		// Only stub undefined methods.
		if ( !console[method] ) {
			console[method] = noop;
		}
	}
}() );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	let activeAlert = null;

	const cssClasses = {
		ALERT_ACTIVE: 'alert-active',
		ALERT_EL: 'alert-el',
		ALERT_HDR: 'alert-header',
		ALERT_INFO: 'alert-info',
		BTN: 'alert-btn',
		BTN_CONFIRM: 'alert-btn-confirm',
		BTN_CONTAINER: 'alert-btn-container',
		BTN_DISMISS: 'alert-btn-dismiss',
		CONTAINER: 'alert-container'
	};

	const keys = {
		ESCAPE: 27
	};

	class Alert {
		constructor() {
			if ( activeAlert ) {
				console.log( 'An alert already exists.' );
				return activeAlert;
			}

			this.alertContainer = this.createAlertElements();

			this.onConfirm = function() { };
			this.onDismiss = function() { };

			this.promptAlert = this.promptAlert.bind( this );
			this.updateButtons = this.updateButtons.bind( this );
			this.showAlert = this.showAlert.bind( this );
			this.handleKeyDown = this.handleKeyDown.bind( this );
			this.dismissAlert = this.dismissAlert.bind( this );

			this.addEventListeners();

			activeAlert = this;
		}

		createAlertElements() {
			// if an existing alert is on the page,
			//   use the same alert element instead of 
			//   adding a second one
			//if ( app.$( '.' + cssClasses.CONTAINER ) ) {
			//	return app.$( '.' + cssClasses.CONTAINER );
			//}
			//else {
			let el = doc.createElement( 'div' );
			el.classList.add( cssClasses.CONTAINER );
			doc.body.appendChild( el );

			this.alertEl = doc.createElement( 'div' );
			this.alertEl.classList.add( cssClasses.ALERT_EL );

			this.alertHeader = doc.createElement( 'h3' );
			this.alertHeader.classList.add( cssClasses.ALERT_HDR );

			this.alertInfo = doc.createElement( 'div' );
			this.alertInfo.classList.add( cssClasses.ALERT_INFO );

			let btnContainer = doc.createElement( 'div' );
			btnContainer.classList.add( cssClasses.BTN_CONTAINER );

			this.btnDismiss = doc.createElement( 'button' );
			this.btnDismiss.classList.add( cssClasses.BTN );
			this.btnDismiss.classList.add( cssClasses.BTN_CONFIRM );
			this.btnDismiss.classList.add( 'btn-ripple' );
			this.btnDismiss.textContent = 'Dismiss';

			this.btnConfirm = doc.createElement( 'button' );
			this.btnConfirm.classList.add( cssClasses.BTN );
			this.btnConfirm.classList.add( cssClasses.BTN_CONFIRM );
			this.btnConfirm.classList.add( 'btn-ripple' );
			this.btnConfirm.textContent = 'Confirm';

			btnContainer.appendChild( this.btnDismiss );
			btnContainer.appendChild( this.btnConfirm );

			el.appendChild( this.alertEl );
			this.alertEl.appendChild( this.alertHeader );
			this.alertEl.appendChild( this.alertInfo );
			this.alertEl.appendChild( btnContainer );

			return el;
			//}
		}

		addEventListeners() {
			this.btnConfirm.addEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.addEventListener( 'click', this.onDismiss, false );
		}

		promptAlert( hdr, content, btnConfirmText, btnDismissText, fnConfirm, fnDismiss ) {
			this.alertHeader.textContent = hdr;
			this.alertInfo.innerHTML = content;
			this.updateButtons( btnConfirmText, btnDismissText, fnConfirm, fnDismiss );
			this.showAlert();

			doc.body.addEventListener( 'keydown', this.handleKeyDown, false );
		}

		updateButtons( btnConfirmText, btnDismissText, fnConfirm, fnDismiss ) {
			this.btnConfirm.textContent = btnConfirmText;
			this.btnDismiss.textContent = btnDismissText;

			this.btnDismiss.MaterialButton = new MaterialButton( this.btnDismiss );
			this.btnConfirm.MaterialButton = new MaterialButton( this.btnConfirm );

			this.btnConfirm.removeEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.removeEventListener( 'click', this.onDismiss, false );

			this.onConfirm = fnConfirm;
			this.onDismiss = fnDismiss;

			this.btnConfirm.addEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.addEventListener( 'click', this.onDismiss, false );
		}

		showAlert() {
			doc.body.classList.add( cssClasses.ALERT_ACTIVE );
		}

		handleKeyDown( e ) {
			if ( e.keyCode === keys.ESCAPE ) {
				this.onDismiss();
			}
		}

		dismissAlert() {
			doc.body.classList.remove( cssClasses.ALERT_ACTIVE );
			doc.body.removeEventListener( 'keydown', this.handleKeyPress, false );
		}
	}

	app.Alert = Alert;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	var MaterialButton = function MaterialButton( element ) {
		this.element_ = element;
		this.init();
	};

	window.MaterialButton = MaterialButton;

	// Definte css classes
	MaterialButton.prototype.cssClasses_ = {
		RIPPLE_BUTTON: 'btn-ripple',
		RIPPLE_CONTAINER: 'btn-ripple-container',
		RIPPLE: 'btn-ripple-element',
		RIPPLE_CENTER: 'btn-ripple-center',
		RIPPLE_IS_ANIMATING: 'is-animating',
		RIPPLE_IS_VISIBLE: 'is-visible'
	};

	MaterialButton.prototype.RippleConstant = {
		INITIAL_SCALE: 'scale(0.0001, 0.0001)',
		INITIAL_SIZE: '1px',
		INITIAL_OPACITY: '0.4',
		FINAL_OPACITY: '0',
		FINAL_SCALE: ''
	};

	// initialize the element
	MaterialButton.prototype.init = function() {
		if ( this.element_ ) {
			
			// if this button needs the ripple effect
			//   add the necessary ripple elements and events
			if ( this.element_.classList.contains( this.cssClasses_.RIPPLE_BUTTON ) ) {
				this.initRipple();
			}
		}
	};

	MaterialButton.prototype.initRipple = function() {
		var recentering;

		// first add the elements
		this.addRippleElements();

		// set defaults and add event handlers
		recentering = this.element_.classList.contains( this.cssClasses_.RIPPLE_CENTER );
		this.frameCount_ = 0;
		this.rippleSize_ = 0;
		this.x_ = 0;
		this.y_ = 0;

		// Touch start produces a compat mouse down event, which would cause a
		// second ripple. To avoid that, we use this property to ignore the first
		// mouse down after a touch start.
		this.ignoringMouseDown_ = false;

		this.boundDownHandler = this.downHandler_.bind( this );
		this.element_.addEventListener( 'mousedown', this.boundDownHandler, false );
		this.element_.addEventListener( 'touchstart', this.boundDownHandler, false );

		this.boundUpHandler = this.upHandler_.bind( this );
		this.element_.addEventListener( 'mouseup', this.boundUpHandler, false );
		this.element_.addEventListener( 'mouseleave', this.boundUpHandler, false );
		this.element_.addEventListener( 'touchend', this.boundUpHandler, false );
		this.element_.addEventListener( 'blur', this.boundUpHandler, false );

		// helpers
		this.getFrameCount = function() {
			return this.frameCount_;
		};

		this.setFrameCount = function( fC ) {
			this.frameCount_ = fC;
		};

		this.getRippleElement = function() {
			return this.rippleElement_;
		};

		this.setRippleXY = function( newX, newY ) {
			this.x_ = newX;
			this.y_ = newY;
		};

		// styles
		this.setRippleStyles = function( start ) {
			if ( this.rippleElement_ !== null ) {
				var transformString, scale, size,
					offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';

				if ( start ) {
					scale = this.RippleConstant.INITIAL_SCALE;
					size = this.RippleConstant.INITIAL_SIZE;
				}
				else {
					scale = this.RippleConstant.FINAL_SCALE;
					size = this.rippleSize_ + 'px';

					if ( recentering ) {
						offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
					}
				}

				transformString = 'translate(-50%, -50%) ' + offset + scale;

				this.rippleElement_.style.webkitTransform = transformString;
				this.rippleElement_.style.msTransform = transformString;
				this.rippleElement_.style.transform = transformString;

				if ( start ) {
					this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_ANIMATING );
				}
				else {
					this.rippleElement_.classList.add( this.cssClasses_.RIPPLE_IS_ANIMATING );
				}
			}
		};

		// RAF
		this.animFrameHandler = function() {
			if ( this.frameCount_-- > 0 ) {
				requestAnimationFrame( this.animFrameHandler.bind( this ) );
			}
			else {
				this.setRippleStyles( false );
			}
		};
	};

	MaterialButton.prototype.addRippleElements = function() {
		var container = doc.createElement( 'span' );
		container.classList.add( this.cssClasses_.RIPPLE_CONTAINER );

		this.rippleElement_ = doc.createElement( 'span' );
		this.rippleElement_.classList.add( this.cssClasses_.RIPPLE );

		container.appendChild( this.rippleElement_ );

		this.boundRippleBlurHandler = this.blurHandler_.bind( this );
		this.rippleElement_.addEventListener( 'mouseup', this.boundRippleBlurHandler );
		this.element_.appendChild( container );
	};

	// blur event handler
	MaterialButton.prototype.blurHandler_ = function( e ) {
		if ( e ) {
			this.element_.blur();
		}
	};

	// disable the button
	MaterialButton.prototype.disable = function() {
		this.element_.disabled = true;
	};

	// button downHandler
	MaterialButton.prototype.downHandler_ = function( e ) {
		var bound, x, y, clientX, clientY;

		if ( !this.rippleElement_.style.width && !this.rippleElement_.style.height ) {
			var rect = this.element_.getBoundingClientRect();
			this.boundHeight = rect.height;
			this.boundWidth = rect.width;
			this.rippleSize_ = Math.sqrt( rect.width * rect.width + rect.height * rect.height ) * 2 + 2;
			this.rippleElement_.style.width = this.rippleSize_ + 'px';
			this.rippleElement_.style.height = this.rippleSize_ + 'px';
		}

		this.rippleElement_.classList.add( this.cssClasses_.RIPPLE_IS_VISIBLE );

		if ( e.type === 'mousedown' && this.ignoringMouseDown_ ) {
			this.ignoringMouseDown_ = false;
		}
		else {
			if ( e.type === 'touchstart' ) {
				this.ignoringMouseDown_ = true;
			}

			var frameCount = this.getFrameCount();
			if ( frameCount > 0 ) {
				return;
			}

			this.setFrameCount( 1 );

			bound = e.currentTarget.getBoundingClientRect();

			// Check if we are handling a keyboard click.
			if ( e.clientX === 0 && e.clientY === 0 ) {
				x = Math.round( bound.width / 2 );
				y = Math.round( bound.height / 2 );
			} else {
				clientX = e.clientX ? e.clientX : e.touches[0].clientX;
				clientY = e.clientY ? e.clientY : e.touches[0].clientY;
				x = Math.round( clientX - bound.left );
				y = Math.round( clientY - bound.top );
			}

			this.setRippleXY( x, y );
			this.setRippleStyles( true );

			window.requestAnimationFrame( this.animFrameHandler.bind( this ) );
		}
	};

	// button upHandler
	MaterialButton.prototype.upHandler_ = function( e ) {
		// Don't fire for the artificial "mouseup" generated by a double-click.
		if ( e && e.detail !== 2 ) {
			this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_VISIBLE );
		}

		// Allow a repaint to occur before removing this class, so the animation
		// shows for tap events, which seem to trigger a mouseup too soon after mousedown.
		window.setTimeout( function() {
			this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_VISIBLE );
		}.bind( this ), 0 );
	};

	// enable the button
	MaterialButton.prototype.enable = function() {
		this.element_.disabled = false;
	};

	app.$.forEach( '.btn-ripple', function( btn ) {
		btn.MaterialButton = new MaterialButton( btn );
	} );
}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	class ContentBox {
		constructor( el ) {
			this.container = el;
			this.img = el.querySelector( '.content-box-img' );
			this.imgEl = this.img.querySelector( 'img' );
			this.imgLoaded = false;
			this.copy = el.querySelector( '.content-box-copy' );

			this.top = this.container.getBoundingClientRect().top;
			
			this.addEvents = this.addEvents.bind( this );
			this.imgLoad = this.imgLoad.bind( this );
			this.checkPosition = this.checkPosition.bind( this );

			this.addEvents();
		}

		addEvents() {
			if ( this.imgEl ) {
				if ( this.imgEl.complete ) {
					this.imgLoaded = true;
					this.checkPosition();
				}
				else {
					this.imgEl.addEventListener( 'load', this.imgLoad );
				}
			}

			window.addEventListener( 'scroll', this.checkPosition );
			window.addEventListener( 'touchmove', this.checkPosition );
		}

		imgLoad() {
			this.top = this.container.getBoundingClientRect().top;
			this.imgLoaded = true;
			this.checkPosition();
		}

		checkPosition() {
			if ( app.$.mq( '(min-width:1024px)' ) ) {
				let y = app.util.getWindowScrollPosition();
				let wh = window.innerHeight;

				if ( y + wh - 120 >= this.top && this.imgLoaded ) {
					this.container.classList.add( 'in' );
				}
			}
		}
	}

	class ContentCards {
		constructor( el ) {
			this.container = el;
			this.top = this.container.getBoundingClientRect().top;

			this.addEvents = this.addEvents.bind( this );
			this.checkPosition = this.checkPosition.bind( this );

			this.addEvents();
		}

		addEvents() {
			window.addEventListener( 'scroll', this.checkPosition );
			window.addEventListener( 'touchmove', this.checkPosition );
		}

		checkPosition() {
			if ( app.$.mq( '(min-width:1024px)' ) ) {
				let y = app.util.getWindowScrollPosition();
				let wh = window.innerHeight;

				if ( y + wh - 50 >= this.top ) {
					this.container.classList.add( 'in' );
				}
			}
		}
	}

	window.addEventListener( 'DOMContentLoaded', () => {
		app.$.forEach( '.content-box', el => {
			new ContentBox( el );
		} );

		app.$.forEach( '.content-cards', el => {
			new ContentCards( el );
		} );
	} );

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const ckEditorSettings = {
		allowedContent: true,
		height: 350,
		toolbar: 'Simple'
	};

	const formCssClasses = {
		chosenSelect: 'chosen-select',
		ckeditor: 'use-ckeditor',
		errorLabel: 'error-label',
		hidden: 'hidden',
		inputField: 'input-field',
		invalid: 'invalid',
		mediumEditor: 'use-medium-editor',
		required: 'req',
		tinyMCE: 'use-tinymce'
	};

	class Form {
		// When creating a new Form, we can pass in a selected element (i.e. doc.querySelect( '#form' ))
		// or we can pass in a selector (i.e. '#form' )
		constructor( el ) {
			if ( typeof el === 'string' ) {
				el = app.$( el );
			}
			
			this.container = el;
			this.fields = el.querySelectorAll( 'input:not([type="file"]),textarea,select' );
			this.reqFields = el.querySelectorAll( '.' + formCssClasses.required );
			this.inputFields = el.querySelectorAll( '.' + formCssClasses.inputField );

			this.initFormElements = this.initFormElements.bind( this );
			this.initEditors = this.initEditors.bind( this );
			this.checkActiveInputs = this.checkActiveInputs.bind( this );
			this.validateFields = this.validateFields.bind( this );
			this.collectData = this.collectData.bind( this );
			this.setFieldValues = this.setFieldValues.bind( this );
			this.clearForm = this.clearForm.bind( this );

			this.initFormElements();
			this.initEditors();
		}

		// This function will loop through all input field elements to check for
		// inputs and select elements to create our custom TextBox or Select objects
		initFormElements() {
			app.$.forEach( this.inputFields, container => {
				let select = container.querySelector( 'select' );
				let input = container.querySelector( 'input' );
				
				if ( select && !select.Select ) {
					select.Select = new app.Select( select );
				}

				if ( !input ) {
					input = container.querySelector( 'textarea' );
				}

				if ( !input ) {
					input = container.querySelector( '.' + formCssClasses.mediumEditor );
				}

				if ( input ) {
					let tag = input.tagName.toLowerCase();
					let type = input.type.toLowerCase();

					if ( !input.TextBox && type !== 'checkbox' && type !== 'radio' ) {
						input.TextBox = new app.TextBox( input );
					}
				}
			} );
		}

		// Helper functions to initialize textareas with MediumEditor or CKEDITOR
		// depending on specified class
		initEditors() {
			app.$.forEach( this.fields, field => {
				if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					if ( !window.MediumEditor ) {
						console.warn( 'MediumEditor source not found. Unable to use MediumEditor.' );
					}
					else {
						new MediumEditor( field, {
							placeholder: {
								text: ''
							}
						} );
					}
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					if ( !window.CKEDITOR ) {
						console.warn( 'CKEDITOR source not found. Unable to use CKEDITOR' );
					}
					else {
						CKEDITOR.replace( field.id, ckEditorSettings );

						if ( field.classList.contains( 'ckfinder' ) ) {
							CKFinder.setupCKEditor( CKEDITOR.instances[field.id], '/ckfinder/' );
						}
					}
				}
				
				if ( app.$( '.' + formCssClasses.tinyMCE ) ) {
					tinymce.init( {
						selector: '.' + formCssClasses.tinyMCE
					} );
				}
			} );
		}

		// Check if inputs/selects have values to set or remove active class
		// on the sibling label
		checkActiveInputs() {
			app.$.forEach( this.inputFields, container => {
				let lbl = container.querySelector( 'label' );
				let select = container.querySelector( 'select' );
				let input = container.querySelector( 'input' );

				if ( lbl ) {
					lbl.classList.remove( 'active' );
				}

				if ( select && select.Select ) {
					select.Select.checkForValue();
				}

				if ( !input ) {
					input = container.querySelector( 'textarea' );
				}

				if ( !input ) {
					input = container.querySelector( '.' + formCssClasses.mediumEditor );
				}

				if ( input && input.TextBox ) {
					input.TextBox.checkForValue();
				}
			} );
		}

		// Helper function to check if required fields have valid data
		validateFields() {
			let isValid = true;

			app.$.forEach( this.reqFields, field => {
				let val = '';
				let tag = field.tagName.toLowerCase();

				if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					val = field.innerHTML;
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					val = CKEDITOR.instances[field.id].getData().trim();
				}
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						val = field.Select.getValue();
					}
					else if ( !field.classList.contains( formCssClasses.chosenSelect ) ) {
						val = field.options[field.selectedIndex].value;
					}
				}
				else {
					val = field.value.trim();
				}

				if ( val === '' || val === '-1' || val === -1 ) {
					field.classList.add( formCssClasses.invalid );
					isValid = false;
				}
				else {
					field.value = val;
					field.classList.remove( formCssClasses.invalid );
				}
			} );

			return isValid;
		}

		// Helper function to collect data from form fields and return as
		// JSON key/value pair object. Uses the element's name attribute as the key.
		collectData() {
			let params = {};

			app.$.forEach( this.fields, field => {
				let key = field.getAttribute( 'name' );
				let val = '';
				let tag = field.tagName.toLowerCase();
				let type = field.type ? field.type.toLowerCase() : '';

				if ( type === 'checkbox' ) {
					val = field.checked;
				}
				else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					val = field.innerHTML;
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					val = CKEDITOR.instances[field.id].getData().trim();
				}
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						val = field.Select.getValue();
					}
					else if ( !field.classList.contains( formCssClasses.chosenSelect ) ) {
						val = field.options[field.selectedIndex].value;
					}
				}
				else {
					val = field.value.trim();

					if ( field.classList.contains( 'integer' ) ) {
						val = parseInt( val, 10 );
					}
					else if ( field.classList.contains( 'decimal' ) ) {
						val = parseFloat( val );
					}
				}

				params[key] = val;
			} );

			return params;
		}

		// Helper function to set the values of form fields. Will use the 
		// name attribute of each field element to select the respective value
		// from the obj parameter.
		setFieldValues( obj ) {
			app.$.forEach( this.fields, field => {
				let val = obj[field.getAttribute( 'name' )];
				let type = field.type ? field.type.toLowerCase() : '';
				let tag = field.tagName.toLowerCase();

				if ( !obj ) {
					console.warn( 'Property does not exist for key ' + field.getAttribute( 'name' ) );
				}
				else {
					if ( type === 'checkbox' ) {
						field.checked = val;
					}
					else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
						field.innerHTML = val;
					}
					else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
						val = CKEDITOR.instances[field.id].setData( val );
					}
					else if ( tag === 'select' && field.Select ) {
						field.Select.setValue( val );
					}
					else {
						if ( field.classList.contains( 'input-date' ) ) {
							if ( obj[field.getAttribute( 'name' ) + 'Str'] ) {
								val = obj[field.getAttribute( 'name' ) + 'Str'];
							}
							else {
								val = moment( val ).format( 'MM/DD/YYYY' );
							}
						}

						field.value = val;
					}
				}
			} );

			this.checkActiveInputs();
		}

		// Helper function to clear out the values of a form. Will additionally
		// remove all HTML from containers with class .row-preview and hide
		// all elements with class .btn-item-upload-delete. It will then
		// run checkActiveInputs to reset the labels.
		clearForm() {
			app.$.forEach( this.fields, field => {
				let lbl = field.querySelector( '.' + formCssClasses.errorLabel );
				let type = field.type ? field.type.toLowerCase() : '';
				let tag = field.tagName.toLowerCase();

				if ( type === 'checkbox' ) {
					field.checked = false;
				}
				else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					field.innerHTML = '';
				}
				else if ( tag === 'textarea' ) {
					if ( field.classList.contains( formCssClasses.ckeditor ) ) {
						CKEDITOR.instances[field.id].setData( '' );
					}
					else {
						field.value = '';
					}
				}
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						field.Select.setValue( '-1' );
					}
					else if ( field.multiple && field.classList.contains( formCssClasses.chosenSelect ) ) {
						app.$.forEach( field.querySelectorAll( 'option' ), function( opt ) {
							opt.selected = false;
						} );

						jQuery( field ).trigger( 'chosen:updated' );
					}
					else {
						field.value = '-1';
					}
				}
				else {
					field.value = '';
				}

				field.classList.remove( formCssClasses.invalid );

				if ( lbl ) {
					field.parentNode.removeChild( lbl );
				}
			} );

			app.$.forEach( '.row-preview', row => {
				row.innerHTML = '';
			}, this.container );

			app.$.forEach( '.btn-item-upload-delete', btn => {
				btn.classList.add( 'hidden' );
			}, this.container );

			this.checkActiveInputs();
		}

		hide() {
			this.container.classList.add( formCssClasses.hidden );
		}

		show() {
			this.checkActiveInputs();
			this.container.classList.remove( formCssClasses.hidden );
		}
	}

	// Expose the Form object to the rest of the project
	app.Form = Form;
}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const config = {
		apiKey: 'AIzaSyAqOORoiVf7epac7Dl0IMxNqBjvkavQRwo'
	};

	let defaults = {
		center: {
		    lat: 32.781769,
		    lng: -96.796817
		},
		scrollwheel: false,
		zoom: 12
	};

	const markerIcons = {
		path: '/img/contact/',
		default: 'marker.v1.png'
	};

	let mapStyles = [{ 'featureType': 'water', 'elementType': 'geometry', 'stylers': [{ 'color': '#e9e9e9' }, { 'lightness': 17 }] }, { 'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 20 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 17 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 29 }, { 'weight': 0.2 }] }, { 'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 18 }] }, { 'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'poi', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 21 }] }, { 'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [{ 'color': '#dedede' }, { 'lightness': 21 }] }, { 'elementType': 'labels.text.stroke', 'stylers': [{ 'visibility': 'on' }, { 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'elementType': 'labels.text.fill', 'stylers': [{ 'saturation': 36 }, { 'color': '#333333' }, { 'lightness': 40 }] }, { 'elementType': 'labels.icon', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'transit', 'elementType': 'geometry', 'stylers': [{ 'color': '#f2f2f2' }, { 'lightness': 19 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 20 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 17 }, { 'weight': 1.2 }] }];

	class Gmap {
		constructor( el, loadCallback ) {
			this.mapEl = el;
			this.map = null;
			
			this.markers = [];
			this.activeMarkerIndex = -1;

			this.loadCallback = loadCallback;

			this.setConfigs = this.setConfigs.bind( this );
			this.addScript = this.addScript.bind( this );
			this.initMap = this.initMap.bind( this );
			this.addMarker = this.addMarker.bind( this );
			this.clearMarkers = this.clearMarkers.bind( this );
			this.triggerResize = this.triggerResize.bind( this );
			this.triggerMarkerClick = this.triggerMarkerClick.bind( this );

			this.setConfigs();
			this.addScript();
		}

		setConfigs() {
			let center = this.mapEl.getAttribute( 'data-map-center' );

			if ( center ) {
				center = center.split( ',' );
				defaults.center.lat = parseFloat( center[0] );
				defaults.center.lng = parseFloat( center[1] );
			}

			let zoom = this.mapEl.getAttribute( 'data-map-zoom' );

			if ( zoom ) {
				defaults.zoom = parseInt( zoom, 10 );
			}
		}

		addScript() {
			app.$.addScript( 'https://maps.googleapis.com/maps/api/js?key=' + config.apiKey, doc.body, true, this.initMap );
		}

		initMap() {
			this.map = new google.maps.Map( this.mapEl, {
				center: defaults.center,
				mapTypeControl: false,
				scrollwheel: defaults.scrollwheel,
				zoom: defaults.zoom
			} );
			
			this.map.setOptions( { styles: mapStyles } );

			if ( this.mapEl.getAttribute( 'data-map-marker' ) ) {
				this.addMarker( {
					lat: defaults.center.lat,
					lng: defaults.center.lng
				} );
			}

			if ( this.loadCallback && typeof this.loadCallback === 'function' ) {
				this.loadCallback( this.map );
			}
		}

		addMarker( data, index, clickFn ) {
			const me = this;

			let marker = new google.maps.Marker( {
				data: data,
				icon: {
					anchor: new google.maps.Point( 13, 36 ),
					size: new google.maps.Size( 26, 36 ),
					url: markerIcons.path + markerIcons.default
				},
				index: index,
				map: this.map,
				position: {
					lat: data.lat,
					lng: data.lng
				}
			} );

			if ( clickFn && typeof clickFn === 'function' ) {
				marker.addListener( 'click', e => {
					clickFn( data, index, marker );
				} );
			}

			this.markers.push( marker );
		}

		clearMarkers() {
			this.markers.forEach( m  => {
				m.setMap( null );
			} );

			this.markers = [];
			this.activeMarkerIndex = -1;
		}

		triggerResize() {
			google.maps.event.trigger( this.map, 'resize' );
			this.map.setCenter( defaults.center );
		}

		triggerMarkerClick( markerIndex ) {
			new google.maps.event.trigger( this.markers[markerIndex], 'click' );
		}
	}

	app.Gmap = Gmap;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ACTIVE: 'admin-modal-in',
		BTN_CLOSE: 'admin-modal-close',
		CONTENT_CONTAINER: 'admin-modal-content'
	};

	class AdminModal {
		constructor( el ) {
			this.container = el;
			this.close = el.querySelector( '.' + cssClasses.BTN_CLOSE );
			this.content = el.querySelector( '.' + cssClasses.CONTENT_CONTAINER );

			this.show = this.show.bind( this );
			this.hide = this.hide.bind( this );
			this.setContent = this.setContent.bind( this );

			this.addEventListeners();

			return this;
		}

		addEventListeners() {
			this.close.addEventListener( 'click', this.hide, false );
		}

		show() {
			doc.body.classList.add( cssClasses.ACTIVE );
		}

		hide() {
			doc.body.classList.remove( cssClasses.ACTIVE );
		}

		setContent( content ) {
			this.content.innerHTML = content;
		}
	}

	app.AdminModal = AdminModal;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	class ParallaxBanner {
		constructor( el ) {
			this.container = el;
			this.src = el.getAttribute( 'data-src' );
			this.mblSrc = el.hasAttribute( 'data-src-mbl' ) ? el.getAttribute( 'data-src-mbl' ) : null;
			this.medSrc = el.hasAttribute( 'data-src-med' ) ? el.getAttribute( 'data-src-med' ) : null;

			if ( !this.src || this.src === '' ) {
				console.warn( 'No source provided.' );
				this.container.classList.add( 'hidden' );
				return;
			}

			this.addImage = this.addImage.bind( this );
			this.addEvents = this.addEvents.bind( this );
			this.checkPosition = this.checkPosition.bind( this );
			this.setImageAndPosition = this.setImageAndPosition.bind( this );
			
			this.setImageAndPosition();
		}

		setImageAndPosition() {
			this.addImage();
			
			if ( app.$.mq( '(min-width:1025px)' ) ) {
				this.addEvents();
				this.checkPosition();
			}
			else if ( app.$.mq( '(max-width:767px)' ) && this.mblSrc ) {
				this.img.style.transform = 'translateY(-22%)';
			}
			else if ( app.$.mq( '(max-width:1023px)' ) && this.mblSrc ) {
				this.img.style.transform = 'translateY(-8.75%)';
			}
			else if ( app.$.mq( '(max-width:1199px)' ) && this.medSrc ) {
				this.img.style.transform = 'translateY(-23%)';
			}
			else {
				this.img.style.transform = 'translateY(-32%)';
			}
		}

		addImage() {
			let existingDiv = this.container.querySelector( 'div' );
			if ( existingDiv ) {
				this.container.removeChild( existingDiv );
			}

			let div = doc.createElement( 'div' );
			div.classList.add( 'parallax-banner-img' );

			if ( app.$.mq( '(max-width:1023px)' ) && this.mblSrc ) {
				div.style.backgroundImage = 'url(' + this.mblSrc + ')';
			}
			else if ( app.$.mq( '(max-width:1199px)' ) && this.medSrc ) {
				div.style.backgroundImage = 'url(' + this.medSrc + ')';
			}
			else {
				div.style.backgroundImage = 'url(' + this.src + ')';
			}

			this.img = div;
			this.container.appendChild( this.img );
		}

		addEvents() {
			window.addEventListener( 'scroll', this.checkPosition );
		}

		checkPosition() {
			let y = app.util.getWindowScrollPosition();
			let wh = window.innerHeight;
			let top = this.container.offsetTop;

			if ( this.container.classList.contains( 'log' ) ) {
				console.log( y, wh, top );
			}

			// determine if the picture is at the bottom of the viewport
			if ( y + wh >= top ) {
				// determine the percentage up the screen the container is
				let diff = 35 - ( ( ( y + wh ) - top ) / wh ) * 100 * 0.225;

				if ( this.container.classList.contains( 'log' ) ) {
					console.log( 'Diff: ' + diff );
				}

				this.img.style.transform = 'translateY(-' + diff + '%)';
			}
		}
	}

	let banners = [];

	window.addEventListener( 'DOMContentLoaded', () => {
		app.$.forEach( '.parallax-banner-container', el => {
			banners.push( new ParallaxBanner( el ) );
		} );
	} );

	window.addEventListener( 'resize', () => {
		banners.forEach( banner => {
			banner.setImageAndPosition();
		} );
	} );

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ERROR_LABEL: 'error-label',
		INVALID_REQ_FIELD: 'invalid',
		MD_MENU: 'md-select',
		MENU: 'md-select-menu',
		MENU_OPEN: 'active',
		LIST_ITEM: 'md-select-menu-item',
		LIST_ITEM_HOVER: 'keyover',
		REQUIRED_FIELD: 'req'
	};

	class Select {
		constructor( select ) {
			// if on a touch device, default to native select
			if ( 'ontouchstart' in doc.documentElement && app.$.mq( '(max-width:1024px)' ) ) {
				return;
			}

			// elements
			this.select = select;
			this.select.classList.add( cssClasses.MD_MENU );
			this.container = this.select.parentNode;
			this.label = this.container.querySelector( 'label' );
			this.menu = null;

			// if this is a multiple select
			this.multiple = this.select.multiple;

			this.open = false;
			this.currentIndex = 0;

			this.listItems = [];

			//this.onChange = function() { };

			this.createMenu = this.createMenu.bind( this );
			this.setMenuPosition = this.setMenuPosition.bind( this );
			this.showMenu = this.showMenu.bind( this );
			this.hideMenu = this.hideMenu.bind( this );
			this.changeHandler = this.changeHandler.bind( this );
			this.focusHanlder = this.focusHanlder.bind( this );
			this.blurHandler = this.blurHandler.bind( this );
			this.keyDownHandler = this.keyDownHandler.bind( this );
			this.bodyClickHandler = this.bodyClickHandler.bind( this );
			this.checkIfRequired = this.checkIfRequired.bind( this );

			this.createMenu();
			this.addEventListeners();
		}

		addEventListeners() {
			this.select.addEventListener( 'focus', this.focusHanlder, false );
			this.select.addEventListener( 'blur', this.blurHandler, false );
		}

		// add change event
		setChangeEvent( fn ) {
			this.onChange = fn;
		}

		// create the drop down
		createMenu() {
			let opts = this.select.children;
			let len = opts.length;
			let i;
			let opt;
			let listItem;
			let li;

			this.menu = doc.createElement( 'ul' );
			this.menu.classList.add( cssClasses.MENU );

			// loop through all of the options and create the ListItems
			for ( i = 0; i < len; i++ ) {
				opt = opts[i];

				listItem = new ListItem( opt, i, this );
				this.listItems.push( listItem );
				this.menu.appendChild( listItem.listItem );
			}

			doc.body.appendChild( this.menu );

			this.setMenuPosition();
		}

		// reset the menu
		reloadMenu() {
			let container;

			if ( this.menu ) {
				container = this.menu.parentNode;
				container.removeChild( this.menu );
				this.listItems = [];
				this.createMenu();
			}
		}

		// set the menu position on the page
		setMenuPosition() {
			const rect = this.select.getBoundingClientRect();
			this.menu.style.top = rect.bottom + app.util.getWindowScrollPosition() + 'px';
			this.menu.style.left = rect.left + 'px';
			this.menu.style.width = this.select.offsetWidth + 'px';
		}

		// show the menu
		showMenu() {
			let me = this;

			// always start at the top of the list
			this.menu.scrollTop = 0;

			this.currentIndex = -1;
			this.menu.classList.add( cssClasses.MENU_OPEN );
			this.open = true;

			setTimeout( function() {
				doc.body.addEventListener( 'keydown', me.keyDownHandler, false );
				doc.body.addEventListener( 'click', me.bodyClickHandler, false );

				me.select.blur();
			}, 100 );
						
			// disable window from scrolling
			app.util.disableWindowScroll();
		}

		// hide the menu
		hideMenu() {
			let item;

			this.menu.classList.remove( cssClasses.MENU_OPEN );
			this.open = false;

			// make sure no listItems ahve the keyover class
			item = this.menu.querySelector( '.' + cssClasses.LIST_ITEM_HOVER );

			if ( item ) {
				item.classList.remove( cssClasses.LIST_ITEM_HOVER );
			}

			// remove event listeners
			doc.body.removeEventListener( 'keydown', this.keyDownHandler, false );
			doc.body.removeEventListener( 'click', this.bodyClickHandler, false );

			// re-enable window scrolling
			app.util.enableWindowScroll();
		}

		focusHanlder( e ) {
			this.setMenuPosition();
			this.showMenu();
		}

		blurHandler( e ) {
			
		}

		keyDownHandler( e ) {
			let index = this.currentIndex;
			let keyCode = -1;
			let menuScrollTop = this.menu.scrollTop;
			let menuHeight = this.menu.offsetHeight;
			let li;

			if ( e && e.keyCode ) {
				keyCode = e.keyCode;
				
				if ( keyCode === 9 ) {
					this.hideMenu();
					e.preventDefault();
				}

				// move down the list
				else if ( keyCode === 40 ) {
					e.preventDefault();
					this.currentIndex++;

					if ( this.currentIndex === this.listItems.length ) {
						this.currentIndex--;
						return;
					}

					if ( index >= 0 ) {
						this.listItems[index].listItem.classList.remove( cssClasses.LIST_ITEM_HOVER );
					}

					li = this.listItems[this.currentIndex].listItem;
					li.classList.add( cssClasses.LIST_ITEM_HOVER );

					// check scroll top
					if ( li.offsetTop + li.offsetHeight > menuScrollTop + menuHeight ) {
						this.menu.scrollTop = menuScrollTop + li.offsetHeight;
					}
				}

				// move up the list
				else if ( keyCode === 38 ) {
					e.preventDefault();
					this.currentIndex--;

					if ( this.currentIndex < 0 ) {
						this.currentIndex = -1;
						return;
					}

					if ( index >= 0 ) {
						this.listItems[index].listItem.classList.remove( cssClasses.LIST_ITEM_HOVER );
					}

					if ( this.currentIndex >= 0 ) {
						li = this.listItems[this.currentIndex].listItem;
						li.classList.add( cssClasses.LIST_ITEM_HOVER );

						// check scroll top
						if ( li.offsetTop < menuScrollTop ) {
							this.menu.scrollTop = menuScrollTop - li.offsetHeight;
						}
					}
				}

				// enter key is clicked
				else if ( keyCode === 13 ) {
					e.preventDefault();

					if ( this.currentIndex === -1 ) {
						this.currentIndex = 0;
					}

					// trigger list item click
					this.listItems[this.currentIndex].selectItem();
				}

				// if escape key is clicked
				else if ( keyCode === 27 ) {
					e.preventDefault();
					this.hideMenu();
				}
			}
		}

		changeHandler( e ) {
			if ( this.onChange && typeof this.onChange === 'function' ) {
				this.onChange();
			}
		}

		bodyClickHandler( e ) {
			if ( e && e.target && ( e.target === this.select || e.target.classList.contains( cssClasses.LIST_ITEM ) || e.target.classList.contains( 'btn-ripple-container' ) || e.target.classList.contains( 'btn-ripple-element' ) ) ) {
				// let the list item click event handle this
			}
			else {
				// clicked outside of the menu, hide the menu
				this.hideMenu();
			}
		}

		checkForValue() {

		}

		checkIfRequired() {
			let selected = this.menu.querySelector( '[selected="true"]' );
			let errorLbl = this.container.querySelector( '.' + cssClasses.ERROR_LABEL );
			let lbl;

			// remove any previous error messages
			if ( errorLbl ) {
				this.container.removeChild( errorLbl );
			}

			// if we don't have a selected option and this is a required field
			if ( !selected && this.select.classList.contains( cssClasses.REQUIRED_FIELD ) ) {
				lbl = doc.createElement( 'span ' );
				lbl.classList.add( cssClasses.ERROR_LABEL );
				lbl.textContent = 'Required field.';
				this.container.appendChild( lbl );
				this.select.classList.add( cssClasses.INVALID_REQ_FIELD );
			}

			// if we're all good, rmeove the invalid class
			else {
				this.select.classList.remove( cssClasses.INVALID_REQ_FIELD );
			}
		}

		setValue( value ) {
			let li = this.menu.querySelector( '[data-val="' + value + '"]' );
			let i = 0;
			let len = this.listItems.length;
			let listItem = null;

			if ( li ) {
				for ( i = 0; i < len; i++ ) {
					listItem = this.listItems[i];

					if ( listItem.listItem === li ) {
						if ( !listItem.listItem.getAttribute( 'selected' ) ) {
							listItem.selectItem();
						}
					}
				}
			}
		}

		getValue() {
			if ( !this.multiple ) {
				return this.select.options[this.select.selectedIndex].value;
			}
		}

		getTextValue() {
			if ( !this.multiple ) {
				return this.select.options[this.selectedIndex].text;
			}
		}
	}

	class ListItem {
		constructor( opt, index, select ) {
			this.listItem = doc.createElement( 'li' );
			this.select = select;
			this.index = index;

			this.listItem.classList.add( cssClasses.LIST_ITEM );
			this.listItem.classList.add( 'btn-ripple' );
			this.listItem.textContent = opt.textContent;
			this.listItem.setAttribute( 'data-val', opt.value );

			if ( opt.selected ) {
				this.listItem.setAttribute( 'selected', 'true' );
			}

			this.selectItem = this.selectItem.bind( this );

			this.addEventListeners();

			return this;
		}

		addEventListeners() {
			this.listItem.addEventListener( 'click', this.selectItem, false );
		}

		selectItem( e ) {
			let selected;
			
			// if clicking the currently selected item
			if ( this.listItem.getAttribute( 'selected' ) === 'true' ) {
				this.listItem.removeAttribute( 'selected' );

				if ( !this.select.multiple ) {
					this.select.select.value = '';
				}

				this.select.checkIfRequired();
			}
			else {
				// check if an item is already selected
				selected = this.select.menu.querySelector( '[selected="true"]' );

				// unselect a previously selected item if this is not a multiple select
				if ( selected && !this.select.multiple ) {
					selected.removeAttribute( 'selected' );
				}

				// select the selected item
				this.listItem.setAttribute( 'selected', 'true' );

				// update the selected element
				if ( !this.select.multiple ) {
					this.select.select.value = this.listItem.getAttribute( 'data-val' );
					this.select.checkIfRequired();
				}

				this.select.select.classList.remove( cssClasses.INVALID_REQ_FIELD );

				// hide the menu if this ins not a multiple select
				if ( !this.select.multiple ) {
					this.select.hideMenu();
				}
			}

			this.select.changeHandler();

			if ( e ) {
				e.stopPropagation();
			}
		}
	}

	app.Select = Select;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ANIMATABLE: 'animatable',
		NAV_IN: 'side-nav-in'
	};

	class SideNav {
		constructor() {
			this.btnShow = app.$( '.hdr-nav-trigger' );
			this.sideNav = app.$( '.side-nav' );
			this.sideNavContainer = app.$( '.side-nav-container' );
			this.sideNavClose = app.$( '.side-nav-close' );

			this.showSideNav = this.showSideNav.bind( this );
			this.hideSideNav = this.hideSideNav.bind( this );
			this.onTouchStart = this.onTouchStart.bind( this );
			this.onTouchMove = this.onTouchMove.bind( this );
			this.onTouchEnd = this.onTouchEnd.bind( this );
			this.onTransitionEnd = this.onTransitionEnd.bind( this );
			this.update = this.update.bind( this );

			this.startX = 0;
			this.currentX = 0;
			this.touchingSideNav = false;

			this.addEventListeners();
		}

		addEventListeners() {
			this.btnShow.addEventListener( 'click', this.showSideNav );
			this.sideNav.addEventListener( 'click', this.hideSideNav );
			this.sideNavContainer.addEventListener( 'click', this.blockClicks );
			this.sideNavClose.addEventListener( 'click', this.hideSideNav );
			this.sideNav.addEventListener( 'touchstart', this.onTouchStart );

			this.sideNav.addEventListener( 'touchmove', this.onTouchMove );
			this.sideNav.addEventListener( 'touchend', this.onTouchEnd );
		}

		showSideNav( e ) {
			this.sideNav.classList.add( cssClasses.ANIMATABLE );
			doc.body.classList.add( cssClasses.NAV_IN );
			this.sideNav.addEventListener( 'transitionend', this.onTransitionEnd );
			e.preventDefault();
		}

		hideSideNav( e ) {
			this.sideNav.classList.add( 'animatable' );
			doc.body.classList.remove( cssClasses.NAV_IN );
			this.sideNav.addEventListener( 'transitionend', this.onTransitionEnd );

			if ( e ) {
				e.preventDefault();
			}
		}

		blockClicks( e ) {
			e.stopPropagation();
		}

		onTouchStart( e ) {
			if ( !doc.body.classList.contains( cssClasses.NAV_IN ) ) {
				return;
			}

			this.startX = e.touches[0].pageX;
			this.currentX = this.startX;

			this.touchingSideNav = true;
			requestAnimationFrame( this.update );
		}

		onTouchMove( e ) {
			if ( !this.touchingSideNav ) {
				return;
			}

			this.currentX = e.touches[0].pageX;
			const translateX = Math.min( 0, this.currentX - this.startX );

			if ( translateX < 0 ) {
				e.preventDefault();
			}
		}

		onTouchEnd( e ) {
			if ( !this.touchingSideNav ) {
				return;
			}

			this.touchingSideNav = false;

			const translateX = Math.min( 0, this.currentX - this.startX );
			this.sideNavContainer.style.transform = '';

			if ( translateX < 0 ) {
				this.hideSideNav();
			}
		}

		update() {
			if ( !this.touchingSideNav ) {
				return;
			}

			requestAnimationFrame( this.update );

			const translateX = Math.min( 0, this.currentX - this.startX );
			this.sideNavContainer.style.transform = 'translateX(' + translateX + 'px)';
		}

		onTransitionEnd( e ) {
			this.sideNav.classList.remove( cssClasses.ANIMATABLE );
			this.sideNav.removeEventListener( 'transitionend', this.onTransitionEnd );
		}
	}

	if ( app.$( '.side-nav' ) ) {
		new SideNav();
	}

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * 
 * Corresponding HTML should follow:
 * 
 * <div class="input-field">
 *   <input type="text" id="tb-mytb" name="dbCol" />
 *   <label for="tb-mytb">Label Text</label>
 * </div>
 * 
 * To make a field required, add class="req"
 * To make a field use a datepicker, add class="input-date"
 * 
 * To autovalidate email, set type="email"
 * To auotvalidate phone numbers, set type="tel" 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ACTIVE_FIELD_CLASS: 'active',
		DATE_SELECTOR: 'input-date',
		ERROR_LABEL: 'error-label',
		INVALID_REQ_FIELD: 'invalid',
		REQUIRED_FIELD: 'req'
	};

	// Regex's for validating field data
	const regExpressions = {
		EMAIL: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
		TEL: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
		DATE: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
	};

	class TextBox {
		// Provide the input element for this TextBox
		constructor( input ) {
			// elements
			this.input = input;
			this.container = input.parentNode;
			this.label = this.container.querySelector( 'label' );

			// check for date
			if ( this.input.classList.contains( cssClasses.DATE_SELECTOR ) ) {
				this.initDatePicker();
			}

			// check for initial value
			this.checkForValue();

			this.initDatePicker = this.initDatePicker.bind( this );
			this.focusHandler = this.focusHandler.bind( this );
			this.blurHandler = this.blurHandler.bind( this );
			this.validateField = this.validateField.bind( this );
			this.checkForValue = this.checkForValue.bind( this );
			this.setValue = this.setValue.bind( this );
			this.getValue = this.getValue.bind( this );

			this.addEventListeners();
		}

		// Add the event listeners
		addEventListeners() {
			this.input.addEventListener( 'focus', this.focusHandler, false );
			this.input.addEventListener( 'blur', this.blurHandler, false );
			this.input.addEventListener( 'change', this.checkForValue, false );
		}

		// Initialize the date picker if the input has class .input-date
		initDatePicker() {
			let field = this.input;
			let picker;

			// make sure it is a text input
			field.type = 'text';

			// if touch device use default date picker
			if ( 'ontouchstart' in doc.documentElement ) {
				field.type = 'date';
				return;
			}

			picker = new Pikaday( {
				field: field,
				format: 'MM/DD/YYYY',
				onSelect: function() {
					field.value = this.getMoment().format( 'MM/DD/YYYY' );
				}
			} );
		}

		// OnFocus event handler
		focusHandler() {
			this.label.classList.add( cssClasses.ACTIVE_FIELD_CLASS );
		}

		// OnBlur event handler
		blurHandler() {
			this.checkForValue();
			this.validateField();
		}

		// Helper function to check for a value and handle the active class of the label
		checkForValue() {
			if ( this.getValue() !== '' ) {
				this.label.classList.add( cssClasses.ACTIVE_FIELD_CLASS );
				this.validateField();
			}
			else {
				this.label.classList.remove( cssClasses.ACTIVE_FIELD_CLASS );
			}
		}

		// Helper function to provide validation of field data based on input type and classes
		validateField() {
			let field = this.input;
			let type = field.type.toLowerCase();
			let valid = true;
			let val = this.getValue();
			let minChars = field.getAttribute( 'min-chars' );
			let prevError = this.container.querySelector( '.' + cssClasses.ERROR_LABEL );
			let lbl;
			let msg = '';

			// check for a value in a required field
			if ( field.classList.contains( cssClasses.REQUIRED_FIELD ) && val === '' ) {
				valid = false;
				msg = 'Required field.';
			}

			// check for min characters
			else if ( minChars && val.length < parseInt( minChars, 10 ) ) {
				valid = false;
				msg = minChars + ' characters required.';
			}

			// check for valid email address
			else if ( type === 'email' && !regExpressions.EMAIL.test( val ) ) {
				valid = false;
				msg = 'Invalid email address.';
			}

			// check for valid phone number
			else if ( type === 'tel' && !regExpressions.TEL.test( val ) ) {
				valid = false;
				msg = 'Inavlid phone number.';
			}

			// check for date
			else if ( field.classList.contains( cssClasses.DATE_SELECTOR ) && !regExpressions.DATE.test( val ) ) {
				valid = false;
				msg = 'Incorrect date format.';
			}

			// remove any previous error messages
			if ( prevError ) {
				this.container.removeChild( prevError );
			}

			// if the field is valid
			if ( valid ) {
				field.classList.remove( cssClasses.INVALID_REQ_FIELD );
			}

			// if invalid, make sure it is highlighted
			else {
				field.classList.add( cssClasses.INVALID_REQ_FIELD );

				// if we have a message
				if ( msg !== '' ) {
					lbl = doc.createElement( 'span' );
					lbl.classList.add( cssClasses.ERROR_LABEL );
					lbl.textContent = msg;
					this.container.appendChild( lbl );
				}
			}
		}

		// Helper function to set the value of the input
		setValue( val ) {
			this.input.value = val;
			this.checkForValue();
			this.validateField();
		}

		// Helper function get the value of the input
		getValue() {
			return this.input.value.trim();
		}
	}

	// Expose the TextBox object to the app
	app.TextBox = TextBox;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ACTIVE: 'active',
		TOAST: 'toast'
	};

	class Toast {
		constructor() {
			this.container = this.createToastElement();
			this.duration = -1;
			this.defaultDuration = 3000;
			this.hideTimeout = null;

			this.show = this.show.bind( this );
			this.hide = this.hide.bind( this );
		}

		createToastElement() {
			// if an existing toast is on the page,
			//   use the same toast element instead of
			//   adding a second one
			if ( app.$( '.' + cssClasses.TOAST ) ) {
				return app.$( '.' + cssClasses.TOAST );
			}
			else {
				let el = doc.createElement( 'div' );
				el.classList.add( cssClasses.TOAST );
				doc.body.appendChild( el );
				return el;
			}
		}

		show( msg, duration ) {
			let me = this;

			if ( this.hideTimeout ) {
				clearTimeout( this.hideTimeout );
				this.hideTimeout = null;
			}

			this.container.innerHTML = msg;

			setTimeout( function() {
				me.container.classList.add( cssClasses.ACTIVE );
			}, 1 );

			this.duration = duration;
			this.hide();
		}

		hide( now ) {
			let me = this,
        		duration = this.defaultDuration;
			
			if ( now ) {
				this.container.classList.remove( cssClasses.ACTIVE );
				return;
			}

			if ( this.duration === -1 ) {
				return;
			}

			if ( this.duration && this.duration !== -1 ) {
				duration = this.duration;
			}

			this.hideTimeout = setTimeout( function() {
				me.container.classList.remove( cssClasses.ACTIVE );
			}, duration );
		}
	}

	app.Toast = Toast;
}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
app.scroll = ( function( doc ) {
	'use strict';

	var hdr = doc.getElementById( 'hdr-main' ),
		links = doc.querySelectorAll( '.link-scroll' ),
		lastY = 0,

		SCROLL_TIME = 500;

	window.forEachElement( links, function( link ) {
		link.addEventListener( 'click', linkClick, false );
	} );

	function linkClick( e ) {
		var selector = this.getAttribute( 'data-scroll-to' ),
			page = doc.querySelector( '[data-scroll="' + selector + '"]' ),
			scrollToYCoord = 0;
		
		if ( page && !this.classList.contains( 'active' ) ) {
			if ( this.classList.contains( 'border' ) ) {
				this.classList.add( 'selected' );
			}

			lastY = app.util.getWindowScrollPosition();
			scrollToYCoord = page.offsetTop - hdr.offsetHeight;

			scrollToY( scrollToYCoord );

			if ( doc.body.classList.contains( 'nav-in' ) ) {
				doc.body.classList.remove( 'nav-in' );
			}

			e.preventDefault();
		}
	}

	function scrollToY( scrollTargetY ) {
		var scrollY = app.util.getWindowScrollPosition(),// window.scrollY,
			speed = SCROLL_TIME,
			easing = easing || 'easeOutSine',
			currentTime = 0,

			time = Math.max( 0.3, Math.min( Math.abs( scrollY - scrollTargetY ) / speed, 0.99 ) ),

			PI_D2 = Math.PI / 2,
			easingEquations = {
				easeOutSine: function( pos ) {
					return Math.sin( pos * ( Math.PI / 2 ) );
				},
				easeInOutSine: function( pos ) {
					return ( -0.5 * ( Math.cos( Math.PI * pos ) - 1 ) );
				},
				easeInOutQuint: function( pos ) {
					if ( ( pos /= 0.5 ) < 1 ) {
						return 0.5 * Math.pow( pos, 5 );
					}
					return 0.5 * ( Math.pow(( pos - 2 ), 5 ) + 2 );
				}
			};

		function tick() {
			currentTime += 1 / 60;

			var p = currentTime / time;
			var t = easingEquations[easing]( p );

			if ( p < 1 ) {
				requestAnimationFrame( tick );

				window.scrollTo( 0, scrollY + ( ( scrollTargetY - scrollY ) * t ) );
			} else {
				window.scrollTo( 0, scrollTargetY );
			}
		}

		tick();
	}

	return {
		scrollToY: scrollToY
	};

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
 app.util = (function( doc ) {
    'use strict';
        
    // will clone an object, not copying by reference
    function cloneObj( obj ) {
        return JSON.parse( JSON.stringify( obj ) );
    }

    function extend( obj1, obj2 ) {
        var obj = obj1;

        for ( var key in obj2 ) {
            obj[key] = obj2[key];
        }

        return obj;
    }

    function getWindowScrollPosition() {
        if ( typeof window.scrollY === 'undefined' ) {
            return document.documentElement.scrollTop;
        }
        else {
            return window.scrollY;
        }
    }

    function callBackFn( instance, fnName ) {
    	return function() {
    		instance[fnName].apply( instance, arguments );
    	};
    }

    function disableWindowScroll() {
    	doc.body.classList.add( 'noscroll' );
    }

    function enableWindowScroll() {
    	doc.body.classList.remove( 'noscroll' );
    }

    return {
        cloneObj: cloneObj,
        extend: extend,
        getWindowScrollPosition: getWindowScrollPosition,
        callBackFn: callBackFn,
        disableWindowScroll: disableWindowScroll,
        enableWindowScroll: enableWindowScroll
    };

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	let btnNavTrigger = app.$( '#btn-nav-trigger' );
	let nav = app.$( '#nav-main' );
	let links;
	let height = 0;
	let y = 0;
	let url = doc.URL.toLowerCase();

	if ( nav ) {
		let linkFound = false;

		window.addEventListener( 'DOMContentLoaded', e => {
			height = nav.offsetHeight;
			y = window.innerHeight - height;
			window.addEventListener( 'scroll', checkPosition );
		} );

		links = nav.querySelectorAll( 'a' );

		app.$.forEach( links, link => {
			let href = link.getAttribute( 'href' );

			if ( href !== '/' && url.indexOf( href ) !== -1 ) {
				link.classList.add( 'active' );
				linkFound = true;
			}
		} );

		if ( !linkFound ) {
			links[1].classList.add( 'active' );
		}

		btnNavTrigger.addEventListener( 'click', e => {
			if ( doc.body.classList.contains( 'nav-in' ) ) {
				doc.body.classList.remove( 'nav-in' );
				btnNavTrigger.querySelector( 'i' ).textContent = 'menu';
			}
			else {
				doc.body.classList.add( 'nav-in' );
				btnNavTrigger.querySelector( 'i' ).textContent = 'close';
			}
		} );
	}

	function checkPosition() {
		let scrollY = app.util.getWindowScrollPosition();

		if ( scrollY >= y ) {
			doc.body.classList.add( 'nav-fixed' );
		}
		else if ( doc.body.classList.contains( 'nav-fixed' ) ) {
			doc.body.classList.remove( 'nav-fixed' );
		}
	}

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	if ( 'serviceWorker' in navigator && doc.URL.indexOf( 'localhost' ) === -1 ) {
		navigator.serviceWorker.register( '/serviceworker.js' ).then( registration => {
			console.log( 'serviceworker registration successful with scope: ' + registration.scope );
		} ).catch( err => {
			console.log( 'serviceworker registration failed: ', err );
		} );
	}

}( document ) );